import { useEffect, useState } from 'react';
import Modal from './Modal';
import { useBlocker } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetDirty } from '../store/reducers/unSavedChangesReducer';

export type UnsavedChangesProps = {
	isDirty: boolean;
	isModalOpen: boolean;
	isNavigationAllowed: boolean;
	handleCancel: null | (() => void);
	handleConfirm: null | (() => void);
};

const UnsavedChanges = ({
	isDirty,
	isModalOpen,
	isNavigationAllowed = true,
	handleCancel,
	handleConfirm,
}: UnsavedChangesProps) => {
	const dispatch = useDispatch();
	const [isModalOpened, setIsModalOpened] = useState(isModalOpen);

	useEffect(() => {
		setIsModalOpened(isModalOpen);
	}, [isModalOpen]);

	const { proceed, reset } = useBlocker(() => {
		if (isDirty) {
			setIsModalOpened(true);
			return true;
		}
		return false;
	});

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleUnsavedChanges = (e: any) => {
		setIsModalOpened(false);
		if (isDirty) {
			e.preventDefault();
			e.returnValue = '';
			return '';
		}
	};

	const handleNo = () => {
		setIsModalOpened(false);
		handleCancel?.();
		if (isNavigationAllowed) {
			reset?.();
		}
	};

	const handleYes = () => {
		setIsModalOpened(false);
		handleConfirm?.();
		if (isNavigationAllowed) {
			dispatch(resetDirty());
			proceed?.();
		}
	};
	useEffect(() => {
		window.addEventListener('beforeunload', handleUnsavedChanges);
		return () => {
			window.removeEventListener('beforeunload', handleUnsavedChanges);
		};
	}, [isDirty]);

	return (
		<Modal
			titleMessage="Are you sure you want to continue? "
			subTitleMessage="The changes made will be lost."
			handleClickNo={handleNo}
			handleClickYes={handleYes}
			isModalOpen={isModalOpened}
		/>
	);
};

export default UnsavedChanges;
